import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { JobLiveRouteEntity } from '../../domain/entities/JobLiveRouteEntity'

export class JobLiveRouteModel extends JobLiveRouteEntity {
  constructor(dataDto: JobLiveRouteModel) {
    super()
    mapEntityProperties<JobLiveRouteEntity>(this, dataDto)
  }
}
